module.exports = __webpack_public_path__ + "img/loading.7057bfe6.gif";